export class InvoiceStatus {
    id: number | undefined
	name: string 

	constructor() {
		this.name = ""
	}
}
